import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import useFullscreenLoaderStyles from './styles/useFullscreenLoaderStyles';

function FullscreenLoader() {
  const styles = useFullscreenLoaderStyles();

  return (
    <Box sx={styles.fullscreenContainer}>
      <CircularProgress sx={styles.loader} data-testid="loader" />
    </Box>
  );
}

export default FullscreenLoader;
